import React, { useState, useEffect, useRef } from "react";
import "../../assets/css/candidate-tab-form.css";
import "../../assets/css/candidate-national-id.css";
import SampleDocsUpload from "../../assets/img/SampleDocsUpload.png";
import InputField from "./../InputField";
import _ from "lodash";
import ImagePopup from "./../ImagePopup";
import ConfirmAadhaar from "./../NID/ConfirmAadhaar";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  validatePAN,
  validateAadhaar,
  validatePassport,
  validateAlphabetsAndSpace,
  validateNumeric,
} from "../../Helper/common";
import {
  getNIDDetails,
  uploadFileViaMultipartNID,
  saveNIDDetails,
  removeUploadedFile,
  deleteSaveNIDDetails,
} from "../../Actions/nidAction";
import { toast } from "react-toastify";
import ImageViewerNID from "../Common/ImageViewerNID";

const NationalIDForm = ({
  field,
  nidOptions,
  fieldKey,
  nidAllDetails,
  NIDKey,
  savedData,
  removeAllDetails,
  // specificNidDetails,
  // errorData,
  // nidDetails,
  // handleInputChange,
  nidFieldIndex,
  // uploadFile,
  // disabledOptionsArray = [],
  // handleFileDelete,
  // showConfirmedAadhaar,
  // confirmedAadhaar,
  // confirmedAadhaarError,
  // handleReEnter,
}) => {
  const [isFileUploadedObject, setIsFileUploadedObject] = useState({
    a: false,
    b: false,
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [nidOptionsArray, setNidOptionsArray] = useState([]);
  const [showImageModal, setShowImageModal] = useState(false);
  const [image, setImage] = useState("");
  const [docType, setDocType] = useState("");
  const [disabledOptionsArray, setDisabledOptionsArray] = useState([]);
  const [confirmedAadhaar, setConfirmedAadhaar] = useState("");
  const [confirmedAadhaarError, setConfirmedAadhaarError] = useState(false);
  const [showConfirmedAadhaar, setShowConfirmedAadhaar] = useState(false);
  const [errorData, setErrorData] = useState({});
  const [nidDetails, setNIDDetails] = useState({}); 
  const [isLoading, setIsLoading] = useState(false);
  const [unsavedNIDDetails, setUnsavedNIDDetails] = useState({});
  const [deletedFileName, setDeletedFileName] = useState(null);
  const [addedFileName, setAddedFileName] = useState(null);
  const [allFields, setAllFields] = useState({});
  const [saveData, setSaveData] = useState({
    nid_selected : [],
    ele_doc_name : [],
    ele_doc_numb : [],
    ele_check_id : []
  })

  const [showImageViewer, setShowImageViewer] = useState(false)

  let user = JSON.parse(localStorage.getItem('userVerificationCandidate'));
  let clientId;

  if(user && (user?.client_id || user?.bridge_client_id)){
    clientId = user?.client_id || user?.bridge_client_id;  
  }
  
  useEffect(() => {
    if (fieldKey === "NID_Default_Field") {
      setNidOptionsArray(nidOptions);
    } else {
      let obj = {};
      let docNumber = null;
      if(field){
        const docValue = field[0].value;
        for (var i in nidOptions) {
          if (nidOptions[i] === docValue) {
            docNumber = i;
          }
        }
        obj[docNumber] = docValue;
        setNidOptionsArray(obj);
      }
    }

  }, []);

  useEffect(() => {
    if(nidAllDetails && Object.keys(nidAllDetails).length > 0){
      if (fieldKey === "NID_Default_Field") {
        setNIDDetails(nidAllDetails?.fields[fieldKey][NIDKey]);
        createErrorData(nidAllDetails?.fields[fieldKey][NIDKey]);
      }else{
        setNIDDetails(nidAllDetails?.fields[fieldKey]);
        createErrorData(nidAllDetails?.fields[fieldKey]);
        // setNIDDetails(field);
        // createErrorData(field)
      }
    }
  },[nidAllDetails, NIDKey
    // ,field
  ])

  useEffect(() => {
    if(field){
      console.log(field);
      let idObj = field[Object.keys(field).length - 1];
      console.log(idObj);
      let id = idObj.value;
      console.log(nidOptions);
      console.log(fieldKey);
      let nid = ''
      if(fieldKey == "NID_Default_Field"){
        nid = setId(field[0].value);
      }else{
       nid = setId(fieldKey);
      }
      if(savedData){
        if(Number.isInteger(NIDKey)){
          handleSavedData(nid, id, NIDKey);
        }else{
          handleSavedData(nid, id);
        }
      }else{
      setSaveData((prev) => ({
        ...prev,
        nid_selected : [nid],
        ele_check_id : [id],
      }))
      }
      if(Number.isInteger(NIDKey)){
        setOptionsArray();
      }
    }
  },[field])

const setOptionsArray = () => {
    if( Number.isInteger(NIDKey)){
      let obj = {...nidOptions}
      if(field[0].field_name == 'nid_selected[]' && field[0].value != ''){
        let val = field[0].value;
        let key = setId(val);
        obj[key] = val;
      }
      setNidOptionsArray(obj);
    }
  }

  const setId = (field, key) => {
    if (field == "Voter_Fields" || field == "VOTER ID") {
      return '142';
    } else if (field == "Passport_Fields" || field == "PASSPORT") {
      return '44';
    } else if (field == "PAN_fields" || field == "PAN CARD") {
      return '45';
    } else if (field == "Aadhaar_Fields" || field == "AADHAAR") {
      return '235';
    } else if (field == "Driving_Fields" || field == "DRIVING LICENSE") {
      return '101';
    } else if (field == "Ghana National ID") {
      return '371';
    }else if (field == 'Other'){
      return '999999';
    }
  };

  const handleSavedData = (nidId, id, key) => {
    let nid,docId,docName,docNum = '';
    let data = _.cloneDeep(field);
    for(var item in data){
        if(data[item].field_name == "nid_selected[]"){
          // nid = data[item].value;
          nid = setId(data[item].value);
          // nid = nidId;
        }
        if(data[item].field_name == "ele_doc_name[]"){
          docName = data[item].value
        }
        if(data[item].field_name == "ele_doc_numb[]" || data[item].field_name == "ghana_national_id"){
          docNum = data[item].value
        }
        if(data[item].field_name == "ele_check_id[]"){
          docId = data[item].value
        }
    }
    setSaveData((prev) => ({
      ...prev,
      nid_selected : [nid],
      ele_doc_name : [docName],
      ele_doc_numb : [docNum],
      ele_check_id : [docId],
    }))
  }

  const handleFileUpload = (inputName, selectedFile, files, errorField) => {
    const arr = fieldKey.split("_");
    const docName = arr[0] == "Aadhaar" ? "aadhaar" : arr[0];
    let docCheckID = null;
    let docSubCheckID = null;
    if (fieldKey !== "NID_Default_Field") {
      for (let i in nidOptions) {
        if (nidOptions[i].toLowerCase().includes(docName.toLowerCase())) {
          docCheckID = i;
        }
      }
    } else {
      docCheckID = 72;
    }

    if (fieldKey === "NID_Default_Field") {
      for (let i in nidOptionsArray) {
        if (nidOptionsArray[i] === nidDetails[0].value ) {
          docSubCheckID = i;
        }
      }
    } else {
      docSubCheckID = docCheckID;
    }
    const docSide = inputName.includes("front") ? "front" : "back";
    const checkIDData = field[Object.keys(field).length - 1].value;
    setErrorData((prev) => ({
      ...prev,
      [inputName] : ''
    }))
    uploadFile(
      docCheckID,
      docSubCheckID,
      docSide,
      fieldKey,
      checkIDData,
      selectedFile,
      inputName,
      nidFieldIndex,
      errorField
    );
  };

  const handleMouseEnter = (e, modalImage) => {
    e.preventDefault();
    e.stopPropagation();
    setImage(modalImage);
    setShowImageViewer(true);
  }

  const handleMouseLeave = (e) => {
    e?.preventDefault();
    e?.stopPropagation();
    setImage("");
    setShowImageViewer(false);
  }

  const handleImageModal = (e, modalImage) => {
    e.preventDefault();
    e.stopPropagation();
    setImage(modalImage);
    setShowImageModal(!showImageModal);
  };

  const closePopup = () => {
    setImage("");
    setShowImageModal(false);
  };

  const handleDelete = (e, errorField, inputName, inputDocId) => {
    e.preventDefault();
    e.stopPropagation();
    const recordArray = {};
    const docSide = inputName.includes("front") ? "front" : "back";
    recordArray.doc_side = docSide;
    recordArray.doc_ids = inputDocId;
    handleFileDelete(recordArray, errorField, inputName);
  };

  useEffect(() => {
    setDocType (nidDetails?.[0]?.value)
  },[nidDetails] )

    const createDisabledOptions = (data) => {
      if (data.fields.NID_Default_Field) {
        let arr = [];
        for (let i = 0; i < data.fields.NID_Default_Field.length; i++) {
          arr.push(data.fields.NID_Default_Field[i][0].value);
        }
        setDisabledOptionsArray(arr);
      }
    };
    const handlePreviewData = (data) => {
      for (let i in data) {
        if (i.includes("NID_Default_Field")) {
          const [field, index, fieldName] = i.split("-");
          let updatedNIDDetails = _.cloneDeep(nidDetails);
          for (let j in updatedNIDDetails.fields[field][index]) {
            if (
              updatedNIDDetails.fields[field][index][j].field_name === fieldName
            ) {
              updatedNIDDetails.fields[field][index][j].value = data[i].preview;
              updatedNIDDetails.fields[field][index][j].id = data[i].docId;
              setErrorData((prevState) => ({
                ...prevState,
                [i]: false,
              }));
              setNIDDetails(updatedNIDDetails);
            }
          }
        } else {
          const [field, fieldName] = i.split("-");
          let updatedNIDDetails = _.cloneDeep(nidDetails);
          for (let j in updatedNIDDetails.fields[field]) {
            if (updatedNIDDetails.fields[field][j].field_name == fieldName) {
              updatedNIDDetails.fields[field][j].value = data[i].preview;
              updatedNIDDetails.fields[field][j].id = data[i].docId;
              setErrorData((prevState) => ({
                ...prevState,
                [i]: false,
              }));
              setNIDDetails(updatedNIDDetails);
            }
          }
        }
      }
    };
    const createErrorData = (data) => {
      const errorObj = {};
      // for (var i in data.fields) {
      //   if (i === "NID_Default_Field") {
      //     for (var j in data.fields[i]) {
      //       for (var k in data.fields[i][j]) {
      //         if (data.fields[i][j][k].is_mandatory === 1) {
      //           errorObj[`${i}-${j}-${data.fields[i][j][k].field_name}`] = false;
      //         }
      //       }
      //     }
      //   } else {
      //     for (var j in data.fields[i]) {
      //       if (data.fields[i][j].is_mandatory === 1) {
      //         errorObj[`${i}-${data.fields[i][j].field_name}`] = false;
      //       }
      //     }
      //   }
      // }
      // let data = _.cloneDeep(nidDetails);
      for(var key in data){
        console.log(data[key]);
        if(data[key].field_name != "nid_selected[]" && data[key].field_name != "ele_check_id[]"){
          if(data[key]?.is_mandatory){
            errorObj[data[key].field_name] = "";
          }
        }
      }

      setErrorData(errorObj);
    };
    
    const saveNidDetails = (e) => {
      e.preventDefault();
      setIsLoading(true);
      let hasError = false;
      // let errors = _.cloneDeep(errorData);
      // for (let i in nidDetails.fields) {
      //   if (i === "NID_Default_Field") {
      //     for (let j in nidDetails.fields[i]) {
      //       for (let k in nidDetails.fields[i][j]) {
      //         if (
      //           nidDetails.fields[i][j][k].is_mandatory === 1 &&
      //           (nidDetails.fields[i][j][k].value === "" ||
      //             nidDetails.fields[i][j][k].value === null)
      //         ) {
      //           if (
      //             nidDetails.fields[i][j][k].field_name.includes("back") ||
      //             nidDetails.fields[i][j][k].field_name.includes("front")
      //           ) {
      //             let isRequired = true;
      //             const nidSelected = nidDetails.fields[i][j][0].value;
      //             const docSide = nidDetails.fields[i][j][k].field_name.includes(
      //               "back"
      //             )
      //               ? "back"
      //               : "front";
      //             if (nidSelected == "PAN CARD" && docSide == "back") {
      //               isRequired = false;
      //             }
      //             if (
      //               nidSelected == "AADHAAR" &&
      //               (docSide == "back" || docSide == "front")
      //             ) {
      //               isRequired = false;
      //             }
      //             hasError = isRequired == true ? true : false;
      //             errors[`${i}-${j}-${nidDetails.fields[i][j][k].field_name}`] =
      //               isRequired == true ? true : false;
      //           } else {
      //             hasError = true;
      //             errors[
      //               `${i}-${j}-${nidDetails.fields[i][j][k].field_name}`
      //             ] = true;
      //           }
      //         }
      //       }
      //     }
      //   } else {
      //     for (let j in nidDetails.fields[i]) {
      //       const isMandatory = nidDetails.fields[i][j].is_mandatory;
      //       const fieldValue = nidDetails.fields[i][j].value;
      //       if (isMandatory == 1 && (fieldValue == "" || fieldValue == null)) {
      //         hasError = true;
      //         errors[`${i}-${nidDetails.fields[i][j].field_name}`] = true;
      //       }
      //     }
      //   }
      // }
      // for (var i in errors) {
      //   if (errors[i] == true) {
      //     hasError = true;
      //     break;
      //   }
      // }
      // if (showConfirmedAadhaar) {
      //   if (confirmedAadhaarError == true) {
      //     hasError = true;
      //   } else if (confirmedAadhaar == "") {
      //     hasError = true;
      //     setConfirmedAadhaarError(true);
      //   }
      // }
      // setErrorData(errors);
            
      hasError = formValidation();

      let ObjError = false;

      Object.values(saveData).map((item) => {
        if(item[0] == '')
        ObjError = true;
      })

      console.log(ObjError)

      console.log(nidDetails);
      console.log(saveData);
      
      if (hasError || ObjError) {
        setIsLoading(false);
        window.scrollTo(0, 0);
        return;
      }
      // sendNidDetails();
      if(saveData?.['nid_selected']?.[0] == "371"){
        let data = _.cloneDeep(nidDetails);
      let a = {};
      let firstName , lastName = '';
        for (let i in data) {
          if (data[i].ibridge_field_id) {
            a[data[i].ibridge_field_id] = data[i].value;
            if(data[i].ibridge_field_id == 492){
              saveData.ele_doc_numb = [data[i].value];
            }else if(data[i].ibridge_field_id == 156){
              firstName = data[i].value;
            }else if(data[i].ibridge_field_id == 158){
              lastName = data[i].value;
            }
          }
        }
      saveData.check_data = a;
      if(firstName && lastName)
      saveData.ele_doc_name = [firstName?.trim() + ' ' + lastName?.trim()];

      console.log(saveData);
      dispatch(saveNIDDetails(saveData));
      }else{
        dispatch(saveNIDDetails(saveData));
      }
    
    };

    const formValidation = () => {
      let errorObj = {};
      let isError = false;
      let data = _.cloneDeep(nidDetails);
      for(var key in data){
        console.log(data[key]);
        if(fieldKey == "NID_Default_Field"){
         if(data[0].field_name == "nid_selected[]" && data[0].value == "AADHAAR"){
          if(data[key].field_name == "ele_doc_name[]" || data[key].field_name == "ele_doc_numb[]"){
            if(data[key]?.is_mandatory && data[key]?.value?.trim() == ''){
              errorObj[data[key].field_name] = "This field is required";
              isError = true;
            }
          }
          if(data[key].field_name == "ele_doc_numb[]"){
            if(data[key]?.is_mandatory && data[key]?.value?.trim() != ''){
              if(!validateAadhaar(data[key].value)){
                errorObj[data[key].field_name] = "Please enter a valid Aadhaar Number";
                isError = true;
              }
            }
          }
         }else if(data[0].field_name == "nid_selected[]" && data[0].value == "PAN CARD"){
          if(data[key].field_name == "ele_doc_name[]" || data[key].field_name == "ele_doc_numb[]" || data[key].field_name == "nid_default_doc_front[]"){
            if(data[key]?.is_mandatory && data[key]?.value?.trim() == ''){
              errorObj[data[key].field_name] = "This field is required";
              isError = true;
            }
          }
          if(data[key].field_name == "ele_doc_numb[]"){
            if(data[key]?.is_mandatory && data[key]?.value?.trim() != ''){
              let flag = validatePAN(data[key].value);
              if(!validatePAN(data[key].value)){
                errorObj[data[key].field_name] = "Please enter a valid PAN Number";
                isError = true;
              }
            }
          }
         }else{
          if(data[key].field_name != "ele_check_id[]"){
            if(data[key]?.is_mandatory && data[key]?.value?.trim() == ''){
                errorObj[data[key].field_name] = "This field is required";
                isError = true;
              }
            }
         } 
        }
        else if(fieldKey == "Aadhaar_Fields" )
        { if(data[key].field_name == "ele_doc_name[]" || data[key].field_name == "ele_doc_numb[]" || data[key].field_name == "aadhar_doc_front" || data[key].field_name == "aadhar_doc_back"){
            if(data[key]?.is_mandatory && data[key]?.value?.trim() == ''|| data[key]?.is_mandatory && data[key]?.value== null){
              errorObj[data[key].field_name] = "This field is required";
              isError = true;
            }
          }
          if(data[key].field_name == "ele_doc_numb[]")
          {if(data[key]?.is_mandatory && data[key]?.value?.trim() != ''){
            if(!validateAadhaar(data[key].value)){
              errorObj[data[key].field_name] = "Please enter a valid Aadhaar Number";
              isError = true;
            }
          }}
        }
        else if(fieldKey == "PAN_fields" )
        {
          if(data[key].field_name == "ele_doc_name[]" || data[key].field_name == "ele_doc_numb[]" || data[key].field_name == "pan_doc_front"){
            if(data[key]?.is_mandatory && data[key]?.value?.trim() == '' || data[key]?.is_mandatory && data[key]?.value== null){
              errorObj[data[key].field_name] = "This field is required";
              isError = true;
            }
          }
          if(data[key].field_name == "ele_doc_numb[]")
          {if(data[key]?.is_mandatory && data[key]?.value?.trim() != ''){
            let flag = validatePAN(data[key].value);
            if(!validatePAN(data[key].value)){
              errorObj[data[key].field_name] = "Please enter a valid PAN Number";
              isError = true;
            }
          }}
        }

        else{
          if(data[key].field_name != "nid_selected[]" && data[key].field_name != "ele_check_id[]"){
            if(data[key]?.is_mandatory && data[key]?.value?.trim() == '' || data[key]?.is_mandatory && data[key]?.value== null){
              errorObj[data[key].field_name] = "This field is required";
              isError = true;
            }
          }
        }
      }
      setErrorData(errorObj);
      return isError;
    }

    console.log(errorData);

    const sendNidDetails = async () => {
      let selectedDocs = [];
      let nid_selected = [];
      let ele_doc_name = [];
      let ele_doc_numb = [];
      let ele_check_id = [];
  
      for (let i in nidDetails.fields) {
        if (i == "NID_Default_Field") {
          for (let j in nidDetails.fields[i]) {
            for (let k in nidDetails.fields[i][j]) {
              if (nidDetails.fields[i][j][k].field_name == "nid_selected[]") {
                selectedDocs.push(nidDetails.fields[i][j][k].value);
              }
              if (nidDetails.fields[i][j][k].field_name == "ele_doc_name[]") {
                ele_doc_name.push(nidDetails.fields[i][j][k].value);
              }
              if (nidDetails.fields[i][j][k].field_name == "ele_doc_numb[]") {
                ele_doc_numb.push(nidDetails.fields[i][j][k].value);
              }
              if (nidDetails.fields[i][j][k].field_name == "ele_check_id[]") {
                ele_check_id.push(nidDetails.fields[i][j][k].value);
              }
            }
          }
        } else {
          for (let j in nidDetails.fields[i]) {
            if (nidDetails.fields[i][j].field_name == "nid_selected[]") {
              selectedDocs.push(nidDetails.fields[i][j].value);
            }
            if (nidDetails.fields[i][j].field_name == "ele_doc_name[]") {
              ele_doc_name.push(nidDetails.fields[i][j].value);
            }
            if (nidDetails.fields[i][j].field_name == "ele_doc_numb[]") {
              ele_doc_numb.push(nidDetails.fields[i][j].value);
            }
            if (nidDetails.fields[i][j].field_name == "ele_check_id[]") {
              ele_check_id.push(nidDetails.fields[i][j].value);
            }
          }
        }
      }
  
      for (let i in selectedDocs) {
        for (let j in nidDetails.Default_Nid_Dropdown) {
          if (selectedDocs[i] == nidDetails.Default_Nid_Dropdown[j]) {
            nid_selected.push(j);
          }
        }
      }
  
      await dispatch(
        saveNIDDetails(nid_selected, ele_doc_name, ele_doc_numb, ele_check_id)
      );
    };

    const handleError = (name, val, fieldKey, index, nidFieldIndex) => {
      const fieldArr =
        fieldKey === "NID_Default_Field"
          ? nidDetails.fields[fieldKey][nidFieldIndex]
          : nidDetails.fields[fieldKey];
      const errorKey =
        fieldKey === "NID_Default_Field"
          ? `${fieldKey}-${nidFieldIndex}-${name}`
          : `${fieldKey}-${name}`;
      let selectedDoc = null;
      for (var i in fieldArr) {
        if (fieldArr[i].field_name == "nid_selected[]") {
          selectedDoc = fieldArr[i].value;
          break;
        }
      }
  
      if (fieldKey === "NID_Default_Field") {
        if (name === "nid_selected[]") {
          setErrorData((prevState) => ({
            ...prevState,
            [errorKey]: val && val !== "" ? false : true,
          }));
        }
      } else {
        if (name === "nid_selected[]") {
          setErrorData((prevState) => ({
            ...prevState,
            [`${fieldKey}-${name}`]: val && val !== "" ? false : true,
          }));
        }
      }
  
      if (name.includes("name")) {
        setErrorData((prevState) => ({
          ...prevState,
          [errorKey]: !validateAlphabetsAndSpace(val),
        }));
      } else if (name.includes("numb")) {
        if (selectedDoc === "PAN CARD") {
          setErrorData((prevState) => ({
            ...prevState,
            [errorKey]: !validatePAN(val),
          }));
        }
        if (selectedDoc === "AADHAAR") {
          //for showing field to re-enter aadhaar
          if (fieldKey == "NID_Default_Field") {
            const hasError = !validateAadhaar(val);
            if (!hasError) {
              setShowConfirmedAadhaar(true);
              setConfirmedAadhaar("");
            } else {
              setShowConfirmedAadhaar(false);
              setConfirmedAadhaar("");
            }
          }
          setErrorData((prevState) => ({
            ...prevState,
            [errorKey]: !validateAadhaar(val),
          }));
        }
        if (selectedDoc === "PASSPORT") {
          setErrorData((prevState) => ({
            ...prevState,
            [errorKey]: !validatePassport(val),
          }));
        }
        if (selectedDoc === "VOTER ID") {
          setErrorData((prevState) => ({
            ...prevState,
            [errorKey]: val !== "" ? false : true,
          }));
        }
        if (selectedDoc === "") {
          setErrorData((prevState) => ({
            ...prevState,
            [errorKey]: val !== "" ? false : true,
          }));
        }
      }
    };
  
    const handleInputChange = (name, val, fieldKey, index, nidFieldIndex, inputField) => {
      // handleError(name, val, fieldKey, index, nidFieldIndex);
      if(name == "ele_doc_name[]"){
      setSaveData((prev) => ({
        ...prev,
        ele_doc_name : [val]
      }))
          }
    
    if(name == "ele_doc_numb[]"){
      setSaveData((prev) => ({
        ...prev,
        ele_doc_numb : [val]
      }))
          }
    let obj = {};    
    let data = _.cloneDeep(nidDetails);
      if (fieldKey == "NID_Default_Field" && name == "nid_selected[]") {
        let arr = _.cloneDeep(disabledOptionsArray);
        arr[nidFieldIndex] = val;
        setDisabledOptionsArray(arr);
        // const currentVal =
        // nidAllDetails.fields["NID_Default_Field"][index][inputField].value;
        const currentVal = nidDetails[0]?.value
        if ((currentVal !== "" && currentVal != null) && val !== currentVal) {
          // removeAllDetails(val, index, inputField, nidFieldIndex);
          obj = {...field};
          for(let i in obj){
            if(obj[i].input_type != 6){
              obj[i].value = '';
            }
          }
          setErrorData((prev) => ({
            ...prev,
            "ele_doc_numb[]" : ''
          }))
          obj[0].value = val;
          // return;
        }
        let id = setId(val);
        
        if(data[0].field_name == "nid_selected[]" && id != null){
          setSaveData((prev) => ({
            ...prev,
            nid_selected : [id]
          })) 
          data[0].value = val;
          setDocType (data[0]?.value)
        }
        if(id == null || id == ''){
          setErrorData((prev) => ({
            ...prev,
            [data[0].field_name] : "This field is required"
          }))
        }
        
      }

      for(var key in data){
        console.log(data[key]);
        if(data[key].field_name == name){
          if(name == 'personal_id_number' || name == 'ghana_national_id'){
            let newVal = val.trim();
            if((validateNumeric(newVal) || name == "ghana_national_id" || name == 'personal_id_number') || val.trim() == ''){
              data[key].value = newVal  ;
              let name = data[key].field_name;
            setErrorData((prev) => ({
              ...prev,
              [name] : ''
            }))
            }
          }else{
            data[key].value = val
            let name = data[key].field_name;
            setErrorData((prev) => ({
              ...prev,
              [name] : ''
            }))
          }
        }
      }

      if(name == "ele_doc_numb[]"){
        if(docType == "AADHAAR" || fieldKey == "Aadhaar_Fields") {
          if(val && !validateAadhaar(val)){
            setErrorData((prev) => ({
              ...prev,
              [name] : "Please enter a valid Aadhaar Number"
            }))
          } else {
            setErrorData((prev) => ({
              ...prev,
              [name] : ''
            }))
          }
        } else if (docType == "PAN CARD" || fieldKey == "PAN_fields") {
          console.log("pan val....", val)
          if(val && !validatePAN(val)){
            setErrorData((prev) => ({
              ...prev,
              [name] : "Please enter a valid PAN Number"
            }))
          } else {
            setErrorData((prev) => ({
              ...prev,
              [name] : ''
            }))
          }
        }
      }
      if(Object.keys(obj).length > 0){
        setNIDDetails(obj);
      }else{
        setNIDDetails(data);
      }
      // if(name == "ele_doc_name[]"){
      // let obj = Object.values(data).filter(
      //   (obj) => obj.field_name == name)
    //   const countryCode = countryCodeOptions.filter(
    //   (obj) => obj?.label?.value == data.mobile_code
    // );
      // obj.value = val; 
        // setNIDDetails((prev) => ({
        //   // ...prev,
        //   data
        // }))
      // }

      // if(name == "ele_doc_numb[]"){

      // }
  
      // if (fieldKey !== "NID_Default_Field") {
      //   console.log(nidDetails);
      //   // setNIDDetails((prevState) => ({
      //   //   ...prevState,
      //   //   fields: {
      //   //     ...prevState.fields,
      //   //     [fieldKey]: {
      //   //       ...prevState.fields[fieldKey],
      //   //       [index]: {
      //   //         ...prevState.fields[fieldKey][index],
      //   //         value: val,
      //   //       },
      //   //     },
      //   //   },
      //   // }));
      //   let data = _.cloneDeep(nidDetails);
        
      //   setNIDDetails((prev) => ({
      //     ...prev,

      //   }))
      // } else {
      //   let updatedNidDetails = _.cloneDeep(nidDetails);
      //   updatedNidDetails.fields[fieldKey][nidFieldIndex][index].value = val;
      //   setNIDDetails(updatedNidDetails);
      // }




    };
  
    const removeAllDetails1 = (val, index, nidFieldIndex) => {
      const nidDetailsClone = _.cloneDeep(nidAllDetails);
      for (var i in nidDetailsClone.fields["NID_Default_Field"][nidFieldIndex]) {
        const fieldName =
          nidDetailsClone.fields["NID_Default_Field"][nidFieldIndex][i]
            .field_name;
        if (fieldName !== "ele_check_id[]") {
          if (fieldName === "nid_selected[]") {
            nidDetailsClone.fields["NID_Default_Field"][nidFieldIndex][i].value =
              val;
          } else {
            nidDetailsClone.fields["NID_Default_Field"][nidFieldIndex][i].value =
              "";
          }
        }
      }
      setNIDDetails(nidDetailsClone);
    };
    
    const uploadFile = async (
      docCheckID,
      docSubCheckID,
      docSide,
      fieldKey,
      checkIDData,
      selectedFile,
      fieldName,
      fieldNIDIndex,
      errorField
    ) => {
      if (docSubCheckID) {
        setAddedFileName(errorField);
        setUnsavedNIDDetails(_.cloneDeep(nidDetails));
        setIsLoading(true);
        await dispatch(
          uploadFileViaMultipartNID(
            docCheckID,
            docSubCheckID,
            docSide,
            fieldKey,
            checkIDData,
            selectedFile,
            fieldName,
            fieldNIDIndex,
            '',
            '' ,
            saveDocCallback,
          )
        );
        // await dispatch(getNIDDetails());
      } else {
        setAddedFileName(null);
        const msg = "Please select the document type first.";
        toast.error(msg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };

    const saveDocCallback = (data, docSide,fieldName, checkIDData,fileName) => {
      console.log("first")
      let url = data?.preview_key || '';
      let docID = data?.document_id || '';
      const fields = _.cloneDeep(nidDetails);
      for(var item in fields){
        if(fields[item].field_name == fieldName){
          fields[item].value = url;
          fields[item].id = docID;
          // fields[item].name = fileName;
        }
    }
    console.log(fields);
    setNIDDetails(fields);
    }
  
    const deleteDocCallback = (data,record, mode, docSide) => {
      console.log("first")
      let url = data?.preview_key || '';
      let docID = data?.document_id || '';
      const fields = _.cloneDeep(nidDetails);
      for(var item in fields){
        if(fields[item].field_name == docSide){
          fields[item].value = url;
          fields[item].id = docID;
          // fields[item].name = fileName;
        }
    }
    console.log(fields);
    setNIDDetails(fields);
    }

    const handleFileDelete = async (recordArr, errorField, docSide) => {
      setIsLoading(true);
      setDeletedFileName(errorField);
      await dispatch(removeUploadedFile("nid_file", recordArr, docSide, deleteDocCallback));
    };
    
    const callbackRefresh = () => {
      dispatch(getNIDDetails());

    }
  
    const handleReEnter = (val) => {
      setConfirmedAadhaar(val);
      const nidFields = nidDetails.fields["NID_Default_Field"];
      let aadhaarNumber = null;
      for (var i in nidFields) {
        for (var j in nidFields[i]) {
          if (
            nidFields[i][j].field_name === "ele_doc_numb[]" &&
            nidFields[i][0].value === "AADHAAR"
          ) {
            aadhaarNumber = nidFields[i][j].value;
          }
        }
      }
      if (aadhaarNumber) {
        if (val == aadhaarNumber) {
          setConfirmedAadhaarError(false);
        } else {
          setConfirmedAadhaarError(true);
        }
      }
    };
  
    const handleSubmitForPreview = (e) => {
      e.preventDefault();
      const currentUrl = window.location.href;
      const [partA, partB] = currentUrl.split("/check-detail/");
      const [reference, route] = partB.split("/");
      navigate(`/case-initiation/profile-preview/${reference}`);
    };

    const handleAddedFile = (newData) => {
      const [fieldKey, fieldName, fieldIndex = null] = addedFileName.split("-");
      const updatedUnsavedData = _.cloneDeep(unsavedNIDDetails);
      if (fieldIndex) {
        for (var i in updatedUnsavedData.fields[fieldKey][fieldName]) {
          if (
            updatedUnsavedData.fields[fieldKey][fieldName][i].field_name ===
            fieldIndex
          ) {
            const newVal = newData.fields[fieldKey][fieldName][i].value;
            updatedUnsavedData.fields[fieldKey][fieldName][i].value = newVal;
          }
        }
      } else {
        for (var i in updatedUnsavedData.fields[fieldKey]) {
          if (updatedUnsavedData.fields[fieldKey][i].field_name === fieldName) {
            const newVal = newData.fields[fieldKey][i].value;
            updatedUnsavedData.fields[fieldKey][i].value = newVal;
          }
        }
      }
      setNIDDetails(updatedUnsavedData);
      setAddedFileName(null);
      createErrorData(updatedUnsavedData);
      createDisabledOptions(updatedUnsavedData);
    };

    const handleDeletedFile = () => {
      const [fieldKey, fieldName, fieldIndex = null] = deletedFileName.split("-");
      const updatedUnsavedData = _.cloneDeep(unsavedNIDDetails);
      if (fieldIndex) {
        for (var i in updatedUnsavedData.fields[fieldKey][fieldName]) {
          if (
            updatedUnsavedData.fields[fieldKey][fieldName][i].field_name ===
            fieldIndex
          ) {
            updatedUnsavedData.fields[fieldKey][fieldName][i].value = "";
          }
        }
      } else {
        for (var i in updatedUnsavedData.fields[fieldKey]) {
          if (updatedUnsavedData.fields[fieldKey][i].field_name === fieldName) {
            updatedUnsavedData.fields[fieldKey][i].value = "";
          }
        }
      }
      setNIDDetails(updatedUnsavedData);
      setDeletedFileName(null);
      createErrorData(updatedUnsavedData);
      createDisabledOptions(updatedUnsavedData);
    };

    const saveDateInput=(name, val, fieldKey, index, nidFieldIndex,inputField,ibridgeFieldId)=>{
      if(name){
        let data = _.cloneDeep(nidDetails);
        for(var key in data){
          if(data[key].field_name == name){
            data[key].value = val
            let name = data[key].field_name;
            setErrorData((prev) => ({
              ...prev,
              [name] : ''
            }))
          }
        }
        // setNidFieldData(data);
        setNIDDetails(data);
        console.log(data);
      }
      }

    const getDateRange = (name) => {
      if(name){
        let data = _.cloneDeep(nidDetails);
        for(var key in data){
          if(name == 'date_of_issue' && data[key].field_name == 'expiry_of_issuance'){
            return data[key].value;
          }
          if(name == 'expiry_of_issuance' && data[key].field_name == 'date_of_issue'){
            return data[key].value;
          }
        }
      }
    }
      return (
    <>
      {showImageModal && (
        <ImagePopup
          showModalBox={1}
          title={"Uploaded file"}
          description={"..."}
          isAdd={true}
          image={image}
          closePopup={closePopup}
        />
      )}
      {
        showImageViewer && (
          <ImageViewerNID
          showModalBox={1}
          title={"ViewUploaded file"}
          description={"..."}
          isAdd={true}
          image={image}
          closePopup={(e)=> handleMouseLeave(e)}
          />
        )
      }
      {nidDetails && Object.keys(nidDetails).map((inputField, key) => {
        const errorField =
          fieldKey === "NID_Default_Field"
            ? `${fieldKey}-${nidFieldIndex}-${nidDetails[inputField].field_name}`
            : `${fieldKey}-${nidDetails[inputField].field_name}`;
        let isPan =
        nidDetails[0].value && nidDetails[0].value == "PAN CARD" ? true : false;
        let showField = true;
        if (field?.[inputField]?.field_name.includes("back") && isPan) {
          showField = false;
        }
        let isAadhaar =
        nidDetails?.[0].value && nidDetails?.[0].value == "AADHAAR" ? true : false;
        if (fieldKey === "NID_Default_Field" && isAadhaar) {
          if (
            nidDetails[inputField].field_name.includes("back") ||
            nidDetails[inputField].field_name.includes("front")
          ) {
            showField = false;
          }
        }
        let uploadedFileName = null;
        if (nidDetails[inputField].input_type == 8) {
          uploadedFileName =
          nidDetails[inputField].filename && nidDetails[inputField].filename != ""
              ? nidDetails[inputField].filename
              : null;
          if (nidDetails[inputField].value == "") {
            uploadedFileName = null;
          }
        }
        // if (nidDetails[inputField].input_type == 1) {
        //   if (nidDetails[inputField].value == null) {
        //     nidDetails[inputField].value
        //   }
        // }
        const fieldName = nidDetails[inputField].field_name;
        let showReEnterField = false;
        if (
          fieldName === "ele_doc_numb[]" &&
          showConfirmedAadhaar &&
          isAadhaar
        ) {
          showReEnterField = true;
        }
        let minimumDate , maximumDate = '';
        if(fieldName == 'date_of_issue'){
          maximumDate = getDateRange(nidDetails[inputField].field_name);
        }
        if(fieldName == 'expiry_of_issuance'){
          minimumDate = getDateRange(nidDetails[inputField].field_name);
        }

        return (
          <>
            {showField && (
              <>
                <div className="row">
                  {nidDetails[inputField].input_type !== 6 ? <div className="col-sm-4 col-md-12 col-xl-4">
                    <div
                      className={
                        nidDetails[inputField].input_type == 8 ? "" : "form-group"
                      }
                    >
                      {(nidDetails[inputField].input_type == 8 && nidDetails[inputField].label == "Upload Document (Front Side)") && <div>
                      <div className="py-2">
            <p className="ques font-weight-bold">Upload {docType}</p>
            <img
              className="w-100"
              style={{ maxWidth: "276.73px" }}
              src={SampleDocsUpload}
              alt="SampleDocsUpload"
            />
          </div>
                        </div>}
                      <InputField
                        inputType={nidDetails[inputField].input_type}
                        inputName={nidDetails[inputField].field_name}
                        inputValue={nidDetails[inputField].input_type == 1 && nidDetails[inputField].value == null ? "" : nidDetails[inputField].value}
                        inputDocId={
                          nidDetails[inputField].id ? nidDetails[inputField].id : null
                        }
                        isInputMandatory={nidDetails[inputField].is_mandatory}
                        inputLabel={!!(fieldKey === "NID_Default_Field" && docType && nidDetails[inputField].label == "ID Number") 
                          ? `${docType} Number` : nidDetails[inputField].label}
                        handleOnChange={(e) =>
                          handleInputChange(
                            e.target.name,
                            e.target.value,
                            fieldKey,
                            key,
                            nidFieldIndex,
                            NIDKey
                          )
                        }
                        options={nidOptionsArray}
                        isFileUploadedObject={isFileUploadedObject}
                        handleFileUpload={handleFileUpload}
                        errorField={errorField}
                        handleDelete={handleDelete}
                        uploadedFileName={uploadedFileName}
                        uploadedFilePreview={
                          nidDetails[inputField].input_type == 8
                            ? nidDetails[inputField].value &&
                            nidDetails[inputField].value != ""
                              ? nidDetails[inputField].value
                              : "n.a."
                            : "n.a."
                        }
                        saveDate={(index, argDate) => {
                          saveDateInput(
                            nidDetails[inputField].field_name,
                            argDate,
                            fieldKey,
                            key,
                            nidFieldIndex,
                            inputField,
                            nidDetails[inputField]?.ibridge_field_id
                          );
                        }}
                        disabledOptionsArray={disabledOptionsArray}
                        handleImageModal={handleImageModal}
                        // errorField={errorField}
                        showBlankOption={
                          fieldKey === "NID_Default_Field" ? true : false
                        }
                        isPan={isPan}
                        nidDetails={nidDetails}
                        minimumDate={minimumDate}
                        maximumDate={maximumDate}
                        handleMouseEnter = {handleMouseEnter}
                        handleMouseLeave = {handleMouseLeave}
                      />
                      {/* {errorData[errorField] && (
                        <p className="text-danger">
                          Please provide valid input
                        </p>
                      )} */}
                      <p className="text-danger">{errorData[nidDetails[inputField].field_name]}</p>
                    </div>
                  </div>:''}
                  {/* {nidDetails[inputField].input_type == 8 &&
                    nidDetails[inputField].value != "" && (
                      <div className="col-auto d-flex align-items-center actions-mbl">
                        <i
                          class="fas fa-eye mr-3 cursor-pointer"
                          onClick={(e) =>
                            handleImageModal(e, nidDetails[inputField].value)
                          }
                        ></i>
                        <i
                          class="fas fa-trash-alt text-danger cursor-pointer"
                          onClick={(e) =>
                            handleDelete(
                              e,
                              errorField,
                              nidDetails[inputField].field_name,
                              nidDetails[inputField].id ? nidDetails[inputField].id : null
                            )
                          }
                        ></i>
                      </div>
                    )} */}
                </div>
              </>
            )}
            {showReEnterField && (
              <>
                <ConfirmAadhaar
                  confirmedAadhaar={confirmedAadhaar}
                  handleReEnter={handleReEnter}
                  confirmedAadhaarError={confirmedAadhaarError}
                />
              </>
            )}
          </>
        );
      })}
                  <div className="row mt-3">
                    <div className="col-auto d-flex justify-content-between">
                      <button
                        className="btn btn-primary btn-lg btn-block mt-3"
                        onClick={(e) => saveNidDetails(e)}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                  {nidAllDetails?.showProfilePreview == 1 && (
                    <div className="row">
                      <div className="col-auto d-flex justify-content-between">
                        <button
                          className="btn btn-primary btn-lg btn-block mt-3"
                          onClick={(e) => handleSubmitForPreview(e)}
                        >
                          {clientId == 459831 ? "Preview" : "Submit for Preview"}
                        </button>
                      </div>
                      <div className="col-auto d-flex justify-content-between mt-4">
                        <small className="text-muted">
                          Please complete all the mandatory fields before final
                          submission
                        </small>
                      </div>
                    </div>
                  )}
    </>
  );
};
export default NationalIDForm;
